/**
 * Selling price rules (must match backend/utils/productPricing.js):
 * - If discount_percentage > 0 and strike_through_price > 0:
 *     selling = strike × (1 − %/100)
 * - Else:
 *     selling = price
 */

export function roundMoney(n) {
  return Math.round((parseFloat(n) || 0) * 100) / 100;
}

export function getProductSellingPrice(product) {
  const strike = parseFloat(product?.strike_through_price) || 0;
  const pct = parseFloat(product?.discount_percentage) || 0;
  const base = parseFloat(product?.price) || 0;

  if (pct > 0 && pct < 99 && strike > 0) {
    return roundMoney(strike * (1 - pct / 100));
  }
  return roundMoney(base);
}

export function getProductDiscountPercent(product) {
  const strike = parseFloat(product?.strike_through_price) || 0;
  const selling = getProductSellingPrice(product);
  const storedPct = parseFloat(product?.discount_percentage) || 0;
  if (storedPct > 0) return Math.round(storedPct);
  if (strike > selling && selling > 0) {
    return Math.round(((strike - selling) / strike) * 100);
  }
  return 0;
}

export function hasActiveProductDiscount(product) {
  const pct = parseFloat(product?.discount_percentage) || 0;
  const strike = parseFloat(product?.strike_through_price) || 0;
  return pct > 0 && strike > 0;
}
